var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid-container"},[_c('div',{staticClass:"footer"},[_c('a',{staticClass:"link",attrs:{"target":"_blank","href":"mailto:contact@weekof.app"}},[_vm._v("contact@weekof.app")]),_vm._v(" © 2023 WeekOf ")])])
}]

export { render, staticRenderFns }